import { render, staticRenderFns } from "./TurmasVazias.vue?vue&type=template&id=3369249c&scoped=true&"
import script from "./TurmasVazias.vue?vue&type=script&lang=js&"
export * from "./TurmasVazias.vue?vue&type=script&lang=js&"
import style0 from "./TurmasVazias.vue?vue&type=style&index=0&id=3369249c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3369249c",
  null
  
)

export default component.exports